module.exports = __webpack_public_path__ + "img/main-bg.png";